import DemoGamePostMessageActions from "./demo_game_post_message_actions";
import GameCommonPostMessageHandler from "./game_common_post_message_handler";


export default class DemoGamePostMessageHandler extends GameCommonPostMessageHandler {
    static CLASS = 'DemoGamePostMessageHandler';

    _createPostMessageActions(gameOptions) {
        return DemoGamePostMessageActions.create({
            serviceFactory: this._serviceFactory,
            isReal: this._isReal,
            gameOptions: gameOptions
        });
    }
}